/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _, { chain, compose, extend, isEmpty, result } from 'underscore';
import $ from 'jquery';
import Promise from 'bluebird';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { FormGroup, Label, Row, Col } from '@bingads-webui-react/primitive';
import { TextField, DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { HelpLink } from '@bingads-webui-react/help-link';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { GoogleLoginRepository, GoogleImportRepository } from '@bingads-webui-campaign/import-shared-repositories';
import { GoogleLoginButton } from '@bingads-webui-campaign/imports-core';
import { fetchInitData } from './repository';
import { loadLegacyDeps, createCommonDeps } from './utils';
import { getImportCredentialIDStyle } from './styles/import-credential-id-page-style';

const MAXLEN = 1000;
const MAXINT32 = 2147483647;
class ImportCredentialId extends React.PureComponent {
  constructor(props) {
    super(props);
    this.perfMarker = props.perfMarker;
    this.GSILocal = result(props.permissions.dynamic, 'GSILocal');
    this.initialize(props);
    this.defaultState = {
      isSignIn: false,
      credentialId: '',
      errorMsg: '',
    };
    this.IsImportCredentialIdShareUserEnabled = result(props.permissions.dynamic, 'ImportCredentialIdShareUser');

    const { shareWithUserIds: shareWithUserIdsOrigin } = this.props.scope.values;
    const shareWithUserIds = this.getValidShareWithUserIds((shareWithUserIdsOrigin || '').toString());

    this.state = extend({
      isInit: false,
      isUserIdSettingExpanded: false,
      shareWithUserIds,
    }, this.defaultState);

    this.signInFailedEmptySessionId = false;
  }

  onSignIn = () => {
    if (this.deps.token) {
      this.signIntoGoogleInDevEnvWithToken();
    } else {
      this.logTrace(`use offline-access consent: ${this.signInFailedEmptySessionId}`);
      new Promise((resolve, reject) => {
        this.googleLoginRepository.googleSignIn({
          onSuccess: resolve,
          onFail: reject,
          useConsentPrompt: this.signInFailedEmptySessionId,
        });
      }).then(response => this.onGoogleAuthSuccess(response))
        .catch((error) => {
          this.logTrace(`failed to login to google import spa, err: ${error && error.authErrors}`);
          if (error.authErrors === 'popup_failed_to_open') {
            this.setState({ errorMsg: this.i18n.get('GoogleImport_AuthorizationError_Popup_Blocked') });
          } else if (error.authErrors === 'idpiframe_initialization_failed') {
            this.setState({ errorMsg: this.i18n.get('GoogleImport_AuthorizationError_Cookies_Disabled') });
          } else if (error.authErrors === 'popup_closed') {
            this.setState({ errorMsg: this.i18n.get('GoogleImport_AuthorizationError_Closed_By_User') });
          } else {
            this.setState({ errorMsg: this.i18n.get('GoogleImport_AuthorizationError') });
          }
        })
        .finally(withUiBlock($('.import-credential-id-page-container'), this.i18n.getString('Loading')));
    }
  };

  onSignOut = () => {
    this.repository.logout();
    this.setState(this.defaultState);
  };

  onCopy = () => {
    window.navigator.clipboard.writeText(this.state.credentialId);
    notificationApi.showInfo(this.props.i18n.getString(_TL_('Copied!')));
  };

  onGoogleAuthSuccess = response => this.processSignIn(this.repository.startGoogleSession(response.code, this.state.shareWithUserIds));

  onUserIdSettingExpand = () => {
    this.setState({
      isUserIdSettingExpanded: true,
    });
  };

  onUserIdChange = (e, val) => {
    if (!val || val.length <= MAXLEN) {
      this.setState({
        userIdsFromInput: val,
      });
    }
  };

  onUserIdConfirm = () => {
    const shareWithUserIds = this.getValidShareWithUserIds(this.state.userIdsFromInput);
    if (!isEmpty(shareWithUserIds)) {
      this.setState({
        shareWithUserIds,
      });
    }
  };

  getValidShareWithUserIds(strIds) {
    if (isEmpty(strIds)) {
      return '';
    }
    const ids = chain(strIds.split(','))
      .map(num => Number(num))
      // userid should be int32.
      .filter(num => num > 0 && num <= MAXINT32)
      .uniq()
      .value();

    return ids.join(',');
  }

  getGoogleAccountName() {
    return this.repository.getGoogleAccountName();
  }

  initialize(props) {
    this.perfMarker.willFetchData();
    const fetchInitDataPromise = fetchInitData(props.scope.values, true);

    fetchInitDataPromise.then((data) => {
      const settings = this.createDeps(data, props);
      return loadLegacyDeps(props)
        .then(spaFactory => spaFactory.initDeps(settings))
        .then((deps) => {
          this.deps = deps;
          this.i18n = this.deps.i18n;
          this.repository = new GoogleImportRepository({
            deps: this.deps,
          });
          this.logTrace(`GSILocal: ${this.GSILocal}`);
          this.googleLoginRepository = new GoogleLoginRepository({ deps: { google: window.google, GSILocal: this.GSILocal } });
          this.setState({ isInit: true });
        });
    });
  }

  createDeps(data, props) {
    const deps = createCommonDeps({
      ...props,
      data,
    });
    extend(deps, {
      perfMarker: this.perfMarker,
    });

    return deps;
  }

  logTrace(...args) {
    this.repository.logTrace(...args);
  }

  signIntoGoogleInDevEnvWithToken = () => this.processSignIn(this.repository.startGoogleSessionWithToken(this.deps.token, this.state.shareWithUserIds));

  processSignIn = startSessionPromise => startSessionPromise.then((sessionId) => {
    if (sessionId) {
      this.setState({
        credentialId: sessionId,
        isSignIn: true,
      });
      this.signInFailedEmptySessionId = false;
    } else {
      this.signInFailedEmptySessionId = true;
      this.setState({ errorMsg: this.i18n.get('GoogleImport_SignInErrorOfflineAccess') });
      this.logTrace('No refresh token on file for account. Showing offline access prompt');
    }
  })
    .catch(err => this.handleError(err))
    .finally(withUiBlock($('.import-credential-id-page-container'), this.i18n.getString('Loading')));

  handleError(err) {
    let code;
    let msg;
    const { i18n } = this;
    const email = this.getGoogleAccountName();

    if (err.body) {
      code = _.propertyOf(err.body[0])('Code');
    }

    switch (code) {
      case 'GoogleSyncNotAdWordsUser':
        msg = i18n.get('CampaignImport_GSyncNotAdsUser').replace('{0}', email);
        break;
      case 'GoogleSyncInvalidCustomerId':
        msg = i18n.get('CampaignImport_GSyncInvalidCustomerId');
        break;
      case 'GoogleSyncOAuthTokenRevoked':
        msg = i18n.get('CampaignImport_GSyncOAuthTokenRevoked');
        break;
      case 'GoogleSyncWebExceptionTimeout':
        msg = i18n.get('CampaignImport_GSyncOperationTimeout');
        break;
      case 'GoogleSyncAccountNotSetUp':
        msg = i18n.get('CampaignImport_GSyncAccountNotSetUp').replace('{0}', email);
        break;
      case 'GoogleSyncUserIsNotAuthorized':
        msg = i18n.get('CampaignImport_GSyncAuthorizationError');
        break;
      case 'GoogleSyncUserPermissionDenied':
        msg = i18n.get('Scheduled_Import_Permission_Error');
        break;
      case 'GoogleSyncTwoStepVerificationNotEnrolled':
        msg = this.deps.i18nErrors.getString(`Error_Campaign_API_${code}`);
        break;
      default:
        break;
    }
    if (msg) {
      // this error will be shown in google sign in step
      this.setState({ errorMsg: msg });
      this.onSignOut();
    } else {
      // this error will be shown on alert center
      this.handleGenericError(err);
    }
  }

  handleGenericError(err) {
    this.repository.logException(err);

    notificationApi.showWarning(this.repository.getLocalizedErrorMessage());
  }

  render() {
    return this.state.isInit ? (
      <div className={classNames(this.props.classes.pageContainer, this.props.classes.importCredentialIdPage, 'import-credential-id-page-container')}>
        <div className="import-page-title">
          <h1>{this.props.i18n.getString(_TL_('Import credential ID'))}</h1>
          <h3 className="page-title-subheader">
            {this.props.i18n.getString(_TL_('An import credential ID is only required by the application programming interface (API) to start importing accounts from Google Ads to Microsoft Advertising. To obtain an import credential ID, please sign in to your Google account.'))}
            &nbsp;
            <span style={{ textDecoration: 'underline', color: '#0078D4' }}>
              <HelpLink query="help:52014">
                {this.props.i18n.getString(_TL_('Learn more about the API.'))}
              </HelpLink>
            </span>
          </h3>
        </div>
        <div className="import-steps">
          <FormGroup>
            <Row>
              <Col sm={12}>
                <Label id="import-owner">
                  {this.props.i18n.getString(_TL_('Owner'))}
                  <HelpPopup topic="pop_BA_Import_Owner" aria-label={this.props.i18n.getString(_TL_('Click to learn more about owner'))} />
                </Label>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <span>
                  {`${this.props.serverContext.CurrentCustomer.Name} - ${this.props.serverContext.CurrentCustomer.Number}`}
                </span>
              </Col>
            </Row>
            {
              isEmpty(this.state.shareWithUserIds) ? <></> :
              <Row className="user-id-text-row">
                <Col sm={12}>
                  <span>{this.props.i18n.getString(_TL_('Will also be shared with user ids: {{userIds}}'), { userIds: this.state.shareWithUserIds })}</span>
                </Col>
              </Row>
            }
            {this.IsImportCredentialIdShareUserEnabled && isEmpty(this.state.shareWithUserIds) ?
              <Row className="user-id-setting-row">
                <Col sm={12}>
                  {this.state.isUserIdSettingExpanded ?
                    <Fragment>
                      <TextField
                        className="userid-text-input"
                        placeholder={this.props.i18n.getString(_TL_('Enter one or many (comma separated) user ids'))}
                        onChange={this.onUserIdChange}
                      />
                      <PrimaryButton
                        className="userid-submit-button"
                        text={this.props.i18n.getString(_TL_('OK'))}
                        onClick={this.onUserIdConfirm}
                      />
                    </Fragment> :
                    <PrimaryButton
                      className="userid-setting-expand-button"
                      text={this.props.i18n.getString(_TL_('Share with more users'))}
                      onClick={this.onUserIdSettingExpand}
                    />}
                </Col>
              </Row> : <></>
            }
          </FormGroup>
          <iframe name="logoutIFrame" style={{ display: 'none' }} />
          {this.state.isSignIn ?
            <Fragment>
              <FormGroup>
                <Row>
                  <Col sm={12}>
                    <Label id="import-google-account">
                      {this.props.i18n.getString(_TL_('Google account'))}
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <span id="google-account-name">
                      {this.getGoogleAccountName()}
                    </span>
                    <DefaultButton
                      className="clickable signout btn-link"
                      onClick={this.onSignOut}
                      text={this.props.i18n.getString(_TL_('Sign out'))}
                    />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col sm={12}>
                    <Label id="import-credential-id-text">
                      {this.props.i18n.getString(_TL_('Import credential ID'))}
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <span>
                      {this.props.i18n.getString(_TL_('Copy or securely store your credential ID. You or your third-party provider will need it to start an API import.'))}
                    </span>
                  </Col>
                </Row>
                <Row className="credential-id-text-copy-row">
                  <Col sm={12}>
                    <div className="credential-id-text">
                      {this.state.credentialId}
                    </div>
                    <PrimaryButton
                      className="copy-button"
                      text={this.props.i18n.getString(_TL_('Copy'))}
                      data-action-name="copy"
                      data-analyticsid="omniture-import-credential-id-copy"
                      onClick={this.onCopy}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Fragment>
            :
            <Fragment>
              {this.state.errorMsg &&
              <FormGroup>
                <span className="error">
                  {this.state.errorMsg}
                </span>
              </FormGroup>
              }
              <FormGroup>
                <GoogleLoginButton
                  i18n={this.props.i18n}
                  onClick={this.onSignIn}
                  data-action-name="sign-in"
                  data-analyticsid="omniture-google-import-sign-in"
                />
              </FormGroup>
            </Fragment>
            }
        </div>
      </div>)
      : (<ProgressiveLoadingBlock />);
  }
}

ImportCredentialId.propTypes = {
  serverContext: PropTypes.shape({
    CurrentCustomer: PropTypes.shape({
      Name: PropTypes.string,
      Number: PropTypes.string,
    }),
  }).isRequired,
  classes: PropTypes.shape({
    pageContainer: PropTypes.string.isRequired,
    importCredentialIdPage: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      shareWithUserIds: PropTypes.string,
    }),
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      ImportCredentialIdShareUser: PropTypes.bool.isRequired,
      GSILocal: PropTypes.bool,
    }),
  }).isRequired,
};

export const StyledImportCredentialId = compose(
  withI18nConsumer,
  WrappedComponent => withSiteMap(withDefaultStyles(WrappedComponent, getImportCredentialIDStyle))
)(ImportCredentialId);
